"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletTooltip = void 0;
const react_1 = __importDefault(require("react"));
const styledComponents_1 = require("../styledComponents");
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = require("styled-components");
const themes_1 = require("@/theme/themes");
const CustomToolTip = ({ description, style }) => {
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
        react_1.default.createElement(styledComponents_1.StyledCustomTooltip, { title: description },
            react_1.default.createElement(material_1.IconButton, { sx: { margin: '0', padding: 0 } }, react_1.default.createElement(styledComponents_1.ThemedInfoIcon, { style: style })))));
};
exports.default = CustomToolTip;
const WalletTooltip = ({ payload }) => {
    return (react_1.default.createElement(styledComponents_1.StyledCustomTooltip, { title: payload },
        react_1.default.createElement(material_1.IconButton, { sx: { margin: '0', padding: 0 } }, react_1.default.createElement(styledComponents_1.ThemedWalletIcon, null))));
};
exports.WalletTooltip = WalletTooltip;
